<template>
  <v-footer padless app dark tile class="sellerNavigationBar">
    <v-btn-toggle
      active-class="active"
    >
      <v-btn to="/portal/chats">
        <v-icon>far fa-comments</v-icon>
        聊天
      </v-btn>
      <v-btn to="/portal/dashboard">
        <v-icon>far fa-user</v-icon>
        我的
      </v-btn>
      <v-btn to="/portal/setting">
        <v-icon>settings</v-icon>
        設定
      </v-btn>
    </v-btn-toggle>
  </v-footer>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.sellerNavigationBar {
  .v-btn-toggle {
    flex-grow: 1;
  }
  .v-btn {
    flex-grow: 1;
    padding: 30px 0 25px 0 !important;   
    border-radius: 0;
    border-color: transparent !important;
    border-width: 0 !important;
    .v-btn__content {
      flex-direction: column;
      font-size: 10px;
      font-weight: 300;
      i {
        font-size: 20px;
        margin-bottom: 2px;
      }
    }
  }
  .active {
    .v-btn__content, i {
      color: $main !important;
    }
    &::before {
      background-color: transparent;
    }
  }
}
</style>